import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import { PeekChip, PeekStack, PeekToggleButton, PeekToggleButtonGroup, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
export const ReportTypeBillingSelector = ({ value, onChange, discountPercentage = 15, }) => {
    const intl = useIntl();
    const theme = useTheme();
    const analytics = useAnalytics();
    const [internalValue, setInternalValue] = useState("annually");
    const selectedBillingOption = value !== null && value !== void 0 ? value : internalValue;
    const handleBillingOptionChange = (event, newValue) => {
        event.stopPropagation();
        if (!newValue || newValue === selectedBillingOption) {
            return;
        }
        analytics === null || analytics === void 0 ? void 0 : analytics.track("Ai Discoverability || Report Plan Billing Toggled", {
            billingOption: newValue,
        });
        if (onChange) {
            onChange(newValue);
        }
        else {
            setInternalValue(newValue);
        }
    };
    return (React.createElement(PeekToggleButtonGroup, { value: selectedBillingOption, exclusive: true, color: "secondary", onChange: handleBillingOptionChange, onClick: (event) => event.stopPropagation(), onMouseDown: (event) => event.stopPropagation(), onKeyDown: (event) => event.stopPropagation(), sx: {
            border: "1px solid",
            borderColor: "grey.200",
            backgroundColor: "grey.100",
            p: 0.25,
            borderRadius: "10px",
            width: "350px",
            alignSelf: "center",
            "& .MuiToggleButton-root": {
                flex: 1,
                border: "none",
                borderRadius: 1,
                boxShadow: "none",
                "&.Mui-selected.MuiToggleButton-secondary": {
                    border: "1px solid !important",
                    fontWeight: "fontWeightMedium !important",
                    borderColor: `${theme.palette.primary.main} !important`,
                    color: `${theme.palette.primary.contrastText} !important`,
                    backgroundColor: `${theme.palette.primary.main} !important`,
                },
            },
            "& .MuiToggleButtonGroup-grouped": {
                borderRadius: "10px !important",
                boxShadow: "none !important",
                fontWeight: "fontWeightLight !important",
                backgroundColor: `transparent !important`,
            },
        } },
        React.createElement(PeekToggleButton, { value: "annually", sx: { p: 0.5 } },
            React.createElement(PeekStack, { direction: "row", alignItems: "center", justifyContent: "center", gap: 1.2 },
                React.createElement(PeekTypography, { variant: "h5", fontWeight: "fontWeightMedium" }, intl.formatMessage(messages.billingOptionAnnually)),
                React.createElement(PeekChip, { size: "small", label: intl.formatMessage(messages.billingOptionDiscount, { discount: discountPercentage }), sx: {
                        "&.MuiChip-root": {
                            border: "0px",
                            color: "secondary.main",
                            backgroundColor: "rgba(255, 255, 255, 0.3)",
                            borderRadius: "10px",
                            "& .MuiChip-label": {
                                px: 0.7,
                                py: 0.3,
                            },
                        },
                    } }))),
        React.createElement(PeekToggleButton, { value: "monthly", sx: { p: 0.5 } },
            React.createElement(PeekTypography, { variant: "h5", fontWeight: "fontWeightMedium" }, intl.formatMessage(messages.billingOptionMonthly)))));
};
export default ReportTypeBillingSelector;
